import { lazy } from 'react'

/**
 * Slug → lazy-loaded module component.
 * Phase 7: all entries are stubs ("em construção"). Phase 8 replaces each
 * with the real UI (dashboard+monitor, agents, resources, tokens).
 */
export const slugToComponent = {
  dashboard: lazy(() => import('../../modules/dashboard/DashboardModule')),
  agents: lazy(() => import('../../modules/agents/AgentsModule')),
  resources: lazy(() => import('../../modules/resources/ResourcesModule')),
  tokens: lazy(() => import('../../modules/tokens/TokensModule')),
  templates: lazy(() => import('../../modules/templates/TemplatesModule')),
  printers: lazy(() => import('../../modules/printers/PrintersModule')),
} as const
